<template>
    <div class="kgk-company-select">
        <button type="button" @click.prevent="selectCompanyButton"><span class="button-text"><i class="fas fa-search"></i> Firma auswählen</span></button>
    </div>
</template>

<script>
// import user from '../../api/user';

import CompanySearch from '@/components/user/CompanySearch';

export default {
    name: 'SelectCompany',
    components: {

    },
    props: {
        currentCompany: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            selection: [],
            createData: null,
            isCreate: false,
        }
    },
    computed: {

    },
    methods: {
        selectCompanyButton() {
            const _this = this;

            let fired = false;

            //this.$modal.show('team-add-member');

            this.$modal.show('dialog', {
                title: 'Firma suchen',
                component: CompanySearch,
                props: {
                    multiple: false,
                    currentCompany: this.currentCompany,
                    //excludeTeam: this.teamIdentifier,
                },
                on: {
                    'selected': _this.handleSelection,
                    'createChanged': _this.handleCreateChanged,
                },
                buttons: [
                    {
                        title: 'Abbrechen',
                        default: true,
                        /*handler() {
                            _this.$modal.hide('dialog');
                        }*/
                    },
                    {
                        title: 'Firma auswählen',
                        handler() {
                            if( fired ) {
                                return;
                            }

                            if( !_this.isCreate && _this.selection.length < 1 ) {
                                return;
                            }
                            if( _this.isCreate && _this.createData === null ) {
                                return;
                            }

                            fired = true;
                            this.title += ' <i class="fas fa-spinner fa-spin"></i>';
                            _this.selectCompany(
                                () => {
                                    let companyData = null;

                                    if( _this.isCreate ) {
                                        companyData = { ..._this.createData, create: true };
                                    }
                                    else {
                                        companyData = { ..._this.selection[0], create: false };
                                    }

                                    _this.$emit('selected', companyData);
                                },
                                () => _this.$modal.hide('dialog')
                            );
                        }
                    }
                ]
            });
        },
        handleSelection(selectedCompanies) {
            console.log('handleSelection', selectedCompanies);
            this.selection = selectedCompanies;
            this.createData = null;
            this.isCreate = false;
        },
        handleCreateChanged(companyData) {
            console.log('handleCreateChanged', companyData);
            this.selection = [];
            this.createData = companyData;
            this.isCreate = true;
        },
        selectCompany(callback, finallyCallback) {
            //const name = this.selection[0].name;

            if( callback ) {
                callback();
            }

            if( finallyCallback ) {
                finallyCallback();
            }
        }
    },
    mounted() {

    }
}
</script>
